export default __webpack_public_path__ + "static/media/benefit_9.9ff88b84.png";